/**
 * StronaFirmyRedirect — resolver pozycji menu „Strona firmy" / „Usługi".
 *
 * Analogicznie do StronaHodowliRedirect: profil firmy jest TWORZONY i ZARZĄDZANY
 * przez Kreator (BusinessWizardV2), a nie przez legacy PageBuilder/PanelOferta.
 *
 * - Ma firmę  → /wizard/firma-v2/{id} (edycja).
 * - Brak firmy → /wizard/firma-v2 (nowa).
 * - ?krok=oferta → otwiera kreator na kroku „Oferta/Usługi".
 */
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/context/AuthContext';
import StudioShell from '@/components/studio/StudioShell';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StronaFirmyRedirect() {
  const navigate = useNavigate();
  const { token } = useAuth();
  const [searchParams] = useSearchParams();
  const krok = searchParams.get('krok');
  const suffix = krok ? `?krok=${krok}` : '';

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/business/my`, { headers: { Authorization: `Bearer ${token}` } });
        const b = (res.data || [])[0];
        if (!active) return;
        navigate(b?.id ? `/wizard/firma-v2/${b.id}${suffix}` : `/wizard/firma-v2${suffix}`, { replace: true });
      } catch {
        if (active) navigate(`/wizard/firma-v2${suffix}`, { replace: true });
      }
    })();
    return () => { active = false; };
  }, [token, navigate, suffix]);

  return (
    <StudioShell mode="workspace" contextLabel="Strona firmy" activeKey={krok === 'oferta' ? 'offer' : 'firmaPage'}>
      <div className="flex items-center justify-center py-40" data-testid="strona-firmy-redirect">
        <Loader2 className="w-7 h-7 animate-spin text-orange-500" />
      </div>
    </StudioShell>
  );
}
